import React, { Component } from 'react'
import { Grid, GridCell } from 'rmwc/Grid'
import { ListDivider } from 'rmwc/List'
import { Typography } from 'rmwc/Typography'
import { Button } from 'rmwc/Button'
import { connect } from 'react-redux'
import { Radio } from 'rmwc/Radio'
import { Select } from 'rmwc/Select'
import { Card } from 'rmwc/Card'
import { Link } from 'react-router-dom'
import { TextField } from 'rmwc/TextField';

import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'


class AddDisplayConfigurationHome extends Component {

	constructor(props){
		super(props);
		this.state = {
			errorMsg: '',
			initalLoadingComplete: false,
			data: {
        page: 1,
        totalPages: '',
				displayConfigurations: [],

			},
		}
	}

	componentDidMount(){
		this.fetchDisplayConfigurations()
	}

	fetchDisplayConfigurations = (e) => {
    let data = Object.assign({}, this.state.data)
    let url = `admin/display/configurations/show?page=${this.state.data.page}&section=Dashboard`
    api.getResponse(this.props.user.accessToken, url).then((result) => {
        const { status, errors} = result
        if (status === 'error') {
          this.setState({ errorMsg: 'Error in Fetching Detail' })  
        }
        else if (status === 'success') {
          data.displayConfigurations = result.data
          data.totalPages = result.count
          this.setState({data:data})
        }
    })
    .catch((err) => {
      this.setState({ errorMsg: 'Error Occured in Fetching Details' })
    })
  }

  handleConfigurationView = (e, configuraitonId) => {
    e.preventDefault();
    let id = configuraitonId
    this.props.history.push(`/portal/app/admin/add/update/display/config/${id}`)
  }

  onInputChange = (e) => {
    let data = Object.assign({}, this.state.data)
    data[e.target.name] = e.target.value
    this.setState({data: data})
  }

  handleFetch = (e) => {
    e.preventDefault()
    this.fetchDisplayConfigurations()
  }

  handleClear = (e) => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data);
    data.page = 1
    data.displayConfigurations = ''
    this.setState({data: data})
  }


	render(){

		let displayConfigurationsComponent
		let activeState
		let imageLink
		let targetLink
    let parentId
		let handleConfigurationView = this.handleConfigurationView

		if(this.state.data.displayConfigurations.length >0){
        displayConfigurationsComponent = 
          ( <tbody>
              {this.state.data.displayConfigurations.map(function(configuraiton) {
                  configuraiton.active ? activeState='Active' : activeState='In Active'
                  
                  configuraiton.image_link ? 
                  	imageLink=<a href ={configuraiton.image_link} target="_blank">Image Link</a> : imageLink='NA'

                  configuraiton.target_link ? 
                  	targetLink=<a href ={configuraiton.target_link} target="_blank">Target Link</a> : targetLink='NA'

                return(<tr key={configuraiton.id}>
                  <td>{configuraiton.id}</td>
                  <td>{configuraiton.section}</td>
                  <td>{configuraiton.name}</td>
                  <td>{configuraiton.listing_sequence}</td>
                  <td>{configuraiton.parent_name}</td>
                  <td><Button dense onClick={((e) => handleConfigurationView(e, configuraiton.id))}>Update</Button></td>
                  <td>{imageLink}</td>
                  <td>{targetLink}</td>
                  <td>{activeState}</td>
                  <td>{configuraiton.created_at}</td>
                  <td>{configuraiton.updated_at}</td>
               </tr>)
              })}
            </tbody>
        )
      }

		return(
			<div>

  	    <Card style={{padding: '1px'}}>
          <Grid>
	            <GridCell span="12">
	              <Typography use="headline5">Display Configuration</Typography>
	            </GridCell>
		          <GridCell span = "2">
		          </GridCell>
            </Grid>
      	</Card>

      	<Grid>
      		<GridCell span="12">
      			 <Link to="/portal/app/admin/add/update/display/config/0"> Add Configuration </Link>
      		</GridCell>
      	</Grid>
        
        <div><ListDivider/></div>

      	<div style={{paddingLeft:'20px', paddingtop:'25px'}}>
          <br/>
          <GridCell span="12">
            Total Pages: {this.state.data.totalPages}
          </GridCell>
          <GridCell spam="12">
            <TextField className='text_input' type='number' label='Page Number' name='page' autoComplete="off" onChange={this.onInputChange} value={this.state.data.page} />
            <Button  onClick={((e) => {this.handleFetch(e)})}>Fetch</Button>
            <Button  onClick={((e) => {this.handleClear(e)})}>Clear</Button>
          </GridCell>

	        <table className="admin-table" style={{width:'95%', overflowX: 'scroll', marginTop:'10px'}}>
	          <thead>
	          	<tr>
			          <th>Id</th>
			          <th>Section</th>
			          <th>Name</th>
			          <th>Listing Sequence</th>
                <th>Entity Name</th>
			          <th>Action</th>
			          <th>Image Link</th>
			          <th>Target Link</th>
			          <th>Active</th>
			          <th>Created On</th>
                <th>Updated On</th>
		          </tr>
		        </thead>  
		          {displayConfigurationsComponent}
		        
	        </table>
      	</div>

      </div>
		)
	}
}


function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AddDisplayConfigurationHome);


// WEBPACK FOOTER //
// ./src/views/admin/AdminDisplayConfigurationHome.jsx